import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
export default function DisclosureItem({button, panel}) {
    return (
        <div className="w-full">
            <div className="mx-auto w-full rounded bg-white border-beige-100/40 border-2 mt-2 p-2">
                <Disclosure>
                    {({ open }) => (
                        <>
                            <Disclosure.Button className="flex w-full justify-between rounded bg-beige-300 px-4 py-2 pt-3 text-left text-sm transition-all hover:bg-beige-100/30 focus:outline-none focus-visible:ring focus-visible:ring-beige-100/30 focus-visible:ring-opacity-75">
                                <span>{button}</span>
                                <ChevronUpIcon
                                    className={`${
                                        open ? 'rotate-180 transform' : ''
                                    } h-5 w-5`}
                                />
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm">
                                {panel}
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            </div>
        </div>
    )
}